import { DatePicker, Input, Pagination, Select, Table } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { createChipAsync, fetchchipsAsync, updateChipAsync, updateChipListAsync } from "../../redux/slice/chips/chipsSlice";
import { NotificationManager } from "react-notifications";

const SetStake = () => {
    const dispatch = useDispatch();
    const { chips, isDefaultChip } = useSelector((state) => state.chips);
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [chipsState, setChips] = useState(chips);
    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchchipsAsync());
        }
    }, [dispatch, isAuthenticated]);

    useEffect(() => {
        setChips(chips);
    }, [chips]);

    const handleChipChange = (index, field, value) => {
        const updatedChips = [...chipsState];
        updatedChips[index] = {
            ...updatedChips[index],
            [field]: value,
            user_id: profileData._id,
            is_active: 'Yes',
            is_delete: 'No'
        };
        setChips(updatedChips);
    };

    const handleSubmit = () => {
        if (isDefaultChip) {
            const data = chipsState.map((chip) => {
                return {
                    user_id: profileData._id,
                    chip_label: chip.chip_label,
                    chip_value: chip.chip_value,
                    is_active: 'Yes',
                    is_delete: 'No'
                }
            });
            dispatch(createChipAsync(data))
                .unwrap()
                .then(() => {
                    dispatch(fetchchipsAsync());
                    NotificationManager.success('Chip created successfully', '', 1000);
                })
                .catch((error) => {
                    console.error('Failed to create chip:', error);
                    NotificationManager.error(error.message || 'Failed to create chip', '', 1000);
                });
        }
        else {
            dispatch(updateChipListAsync(chipsState))
                .unwrap()
                .then(() => {
                    dispatch(fetchchipsAsync());
                    NotificationManager.success('Chip updated successfully', '', 1000);
                })
                .catch((error) => {
                    console.error('Failed to update chip:', error);
                    NotificationManager.error(error.message || 'Failed to update chip', '', 1000);
                });
        }
    }

    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12 lg:px-[6px] mt-[.5rem] lg:mt-0'>
                <div className='col-span-12'>
                    <div className='relative w-full'>
                        <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Set Stake</p>
                        {isDefaultChip && (
                            <p className='bg-[#18adc5] text-[#d50000] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>*These are the Default Chips please submit the form to save the changes.</p>
                        )}
                    </div>
                    <div className="bg-[#fff] text-[#000] mb-[10px] min-h-[500px] w-full">
                        <div className="p-[.5rem]">
                            <table className="!text-[#000] w-full whitespace-nowrap !mb-[.25rem]">
                                <thead>
                                    <tr className="!bg-[#028dad] !text-[#fff]">
                                        <th className="text-[13px] leading-[16px] !p-[8px]  border-b-[2px_solid_#dee2e6] align-bottom border-[1px] border-[solid] border-[#dee2e6]">ID</th>
                                        <th className="text-[13px] leading-[16px] !p-[8px]  border-b-[2px_solid_#dee2e6] align-bottom border-[1px] border-[solid] border-[#dee2e6]">Button Name</th>
                                        <th className="text-[13px] leading-[16px] !p-[8px]  border-b-[2px_solid_#dee2e6] align-bottom border-[1px] border-[solid] border-[#dee2e6]">Button Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chipsState.length > 0 && chipsState?.map((chip, index) => (
                                        <tr key={index}>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]">{index + 1}</td>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding bg-[#fff] border-[1px] border-[solid] border-[#ced4da] rounded-[.25rem] text-[#495057] block font-normal leading-normal w-full outline-none"
                                                    value={chip?.chip_label}
                                                    onChange={(e) => handleChipChange(index, 'chip_label', e.target.value)}
                                                />
                                            </td>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]">
                                                <input
                                                    type="text"
                                                    name="value"
                                                    className="text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding bg-[#fff] border-[1px] border-[solid] border-[#ced4da] rounded-[.25rem] text-[#495057] block font-normal leading-normal w-full outline-none"
                                                    value={chip?.chip_value}
                                                    onChange={(e) => handleChipChange(index, 'chip_value', e.target.value)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="!text-left !pl-[.25rem] !pr-[.25rem] !ml-0 !mr-0 flex flex-wrap">
                            <div className=" !mb-4 !mt-4 relative w-full !px-[6px] !py-[0]">
                                <button onClick={handleSubmit} className="cursor-pointer bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center">Submit</button>
                            </div>
                        </div>
                    </div>
                </div >

            </div >
        </div >
    )
}
export default SetStake